
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_47742","data-name":"Group 47742","xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_47750","data-name":"Group 47750"}},[_c('path',{attrs:{"id":"Path_33940","data-name":"Path 33940","d":"M6 0h13a6 6 0 016 6v13a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6","fill":"#f4f6f9"}}),_c('path',{attrs:{"id":"Path_33941","data-name":"Path 33941","d":"M7.083 7.27a1.467 1.467 0 012.17-1.354l9.008 5.231a1.587 1.587 0 010 2.706l-9.008 5.231a1.467 1.467 0 01-2.17-1.355z","fill":"none","stroke":"#727998","stroke-width":"1.5"}})])])
          )
        }
      }
    